import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';

var bnrimg = require('../../images/contact.png');

// archlib-backend manda el correo de contacto vía Outlook (POST /contacto, ruta
// pública). Usa el MISMO REACT_APP_BACKEND_URL que ya usa el registro.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const CONTACT_ENDPOINT = process.env.REACT_APP_CONTACT_ENDPOINT
    || (BACKEND_URL ? BACKEND_URL.replace(/\/$/, '') + '/contacto' : '/contacto');

const ContactUs = () => {
    const { t } = useTranslation();
    const [form, setForm] = useState({ nombre: '', email: '', mensaje: '' });
    const [status, setStatus] = useState('idle'); // idle | sending | sent | error

    const change = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.nombre.trim() || !form.email.trim() || !form.mensaje.trim()) {
            setStatus('error');
            return;
        }
        setStatus('sending');
        try {
            const res = await fetch(CONTACT_ENDPOINT, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(form),
            });
            if (!res.ok) throw new Error('server error');
            setStatus('sent');
            setForm({ nombre: '', email: '', mensaje: '' });
        } catch {
            setStatus('error');
        }
    };

    return (
        <>
            <Header />
            <div className="page-content">
                <Banner title={t('pages.contact.title')} pagename={t('pages.contact.breadcrumb')} description={t('pages.contact.description')} bgimage={bnrimg}/>
                {/* SECTION CONTENTG START */}
                <div className="section-full p-tb80 inner-page-padding">
                    {/* LOCATION BLOCK*/}
                    <div className="container">
                        {/* GOOGLE MAP & CONTACT FORM */}
                        <div className="section-content">
                            {/* CONTACT FORM*/}
                            <div className="row">
                                <div className="col-lg-8 col-md-12 col-sm-12">
                                    <form className="contact-form cons-contact-form bg-gray p-a30" onSubmit={handleSubmit}>
                                        <div className="contact-one">
                                            {/* TITLE START */}
                                            <div className="section-head">
                                                <div className="sx-separator-outer separator-left">
                                                    <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(images/background/cross-line2.png)' }}>
                                                        <h3 className="sep-line-one">{t('pages.contact.formTitle')}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* TITLE END */}
                                            <div className="form-group">
                                                <input name="username" type="text" required className="form-control" placeholder={t('pages.contact.name')} value={form.nombre} onChange={change('nombre')} />
                                            </div>
                                            <div className="form-group">
                                                <input name="email" type="email" className="form-control" required placeholder={t('pages.contact.email')} value={form.email} onChange={change('email')} />
                                            </div>
                                            <div className="form-group">
                                                <textarea name="message" rows={4} className="form-control " required placeholder={t('pages.contact.message')} value={form.mensaje} onChange={change('mensaje')} />
                                            </div>
                                            <div className="text-right">
                                                <button name="submit" type="submit" value="Submit" className="site-button btn-half" disabled={status === 'sending'}>
                                                    <span>{status === 'sending' ? t('pages.contact.sending') : t('pages.contact.send')}</span>
                                                </button>
                                            </div>
                                            {status === 'sent' && (
                                                <p style={{ color: '#1f8a52', marginTop: '12px', fontWeight: 600 }}>
                                                    {t('pages.contact.success')}
                                                </p>
                                            )}
                                            {status === 'error' && (
                                                <p style={{ color: '#c0392b', marginTop: '12px', fontWeight: 600 }}>
                                                    {t('pages.contact.error')}
                                                </p>
                                            )}
                                        </div>
                                    </form>
                                </div>
                                <div className="col-lg-4 col-md-12 col-sm-12">
                                    <div className="contact-info block-shadow bg-white bg-center p-a40" style={{ backgroundImage: 'url(images/background/bg-map.png)' }}>
                                        <div>
                                            {/* TITLE START */}
                                            <div className="section-head">
                                                <div className="sx-separator-outer separator-left">
                                                    <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(images/background/cross-line2.png)' }}>
                                                        <h3 className="sep-line-one">{t('pages.contact.infoTitle')}</h3>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* TITLE END */}
                                            {/* Teléfonos ocultos por ahora */}
                                            <div className="sx-icon-box-wraper left p-b30">
                                                <div className="icon-xs"><i className="fa fa-envelope" /></div>
                                                <div className="icon-content">
                                                    <h5 className="m-t0">{t('pages.contact.emailLabel')}</h5>
                                                    <p>ccustomer-service@soltarc.com</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* SECTION CONTENT END */}
            </div>

            <Footer />
        </>
    );
};

export default ContactUs;
